import { FC } from "preact/compat";
import { useSignal } from "@preact/signals";
import { DiscoveryDetailsRenderer } from "../DiscoveryDetailsRenderer";
import { GuideExampleProps } from "./interfaces";
import PencilIcon from "@material-design-icons/svg/outlined/create.svg";
import PictureIcon from "@material-design-icons/svg/outlined/image.svg";
import cn from "classnames";

const GuideExample: FC<GuideExampleProps> = ({ content, className }) => {
    const value = useSignal(content);

    return (
        <div className={cn("w-full flex gap-x-4", className)}>
            <div className="w-1/2 flex flex-col">
                <div className="text-sm text-gray-500 flex items-center mb-1">
                    <PencilIcon width="16" height="16" className="mr-1" />
                    <span>Content</span>
                </div>
                <textarea
                    value={value}
                    onInput={({ currentTarget }) =>
                        (value.value = currentTarget.value)
                    }
                    className="resize-none w-full h-full border rounded-lg border-gray-300 p-3"
                />
            </div>
            <div className="w-1/2 flex flex-col">
                <div className="text-sm text-gray-500 flex items-center mb-1">
                    <PictureIcon width="16" height="16" className="mr-1" />
                    <span>Preview</span>
                </div>
                <div className="border rounded-lg border-gray-300 p-3 h-full">
                    <DiscoveryDetailsRenderer details={value.value} />
                </div>
            </div>
        </div>
    );
};

export default GuideExample;
